import { Injectable } from '@angular/core';
import { AppLink } from './appLinksCfg.service';
import { LoggerService } from '../logging/logger.service';
import '../../util/string';

@Injectable({
  providedIn: 'root'
})
export class AppLinkNavigatorService {
  constructor(private logger: LoggerService) {
  }

  public async navigate(appLink: AppLink): Promise<void> {
    try {

      let processedLink = appLink.link;

      if (processedLink) {
        this.logger.traceActivity(`Acceso a ${appLink.name}`);
          window.open(processedLink, "_blank");
      }
    } catch (error) {
      this.logger.error(error.message);
      throw error;
    }
  }
}
